<div>
  <div class="d-flex justify-content-end">
    <div class="form-check form-switch">
      @if(disableAll || isReadOnly){ @if(!isManualAddress){
      <i class="fa fa-xmark" style="color: red"></i>
      }@else{
      <i class="fa fa-check" style="color: green"></i>
      } }@else{
      <input
        class="form-check-input"
        type="checkbox"
        [(ngModel)]="isManualAddress"
        (ngModelChange)="onManualAddressChange()"
        id="manualAddressSwitch"
        [disabled]="disableAll"
      />}
      <label class="form-check-label" for="isManualAddress">
        {{ "address.manuel-address" | translate }}
      </label>
    </div>
  </div>

  <div class="row" *ngIf="!this.isManualAddress" [formGroup]="addressForm">
    <div class="row">
      <div class="col-xl-12 mb-1">
        <label for="formattedAddress" class="form-label required-star">{{
          "address.address" | translate
        }}</label>

        @if(disableAll || isReadOnly){
        <div class="d-flex">
          <div style="flex: 1">
            <app-readonly-input
              [value]="addressForm.controls['formattedAddress']?.value"
            ></app-readonly-input>
          </div>
          <span
            class="input-group-text"
            (click)="onNavigateIconClick()"
            style="cursor: pointer" role="button"  tabindex="-1"
          >
            <i class="bi bi-compass"></i>
          </span>
        </div>
        } @else {
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Açık Adres"
            formControlName="formattedAddress"
            appGoogleAutocomplete
            (placeChanged)="onPlaceChanged($event)"
          />
          <span
            class="input-group-text"
            (click)="onNavigateIconClick()"
            style="cursor: pointer" role="button"  tabindex="-1"
          >
            <i class="bi bi-compass"></i>
          </span>

          <span
            *ngIf="patient?.addresses && patient.addresses.length > 0"
            class="input-group-text"
            (click)="onSearchIconClick()" role="button"  tabindex="-1"
            style="cursor: pointer"
          >
            <i class="bi bi-search"></i>
          </span>
           <span *ngIf="patient?.addresses && patient.addresses.length > 0" class="custom-badge">
            {{patient?.addresses?.length}}
          </span>
        </div>
        }
        <div
          *ngIf="addressForm.errors?.['formattedAddress'] && (addressForm.get('formattedAddress')?.dirty || addressForm.get('formattedAddress')?.touched)"
        >
          <small
            class="text-danger"
            >{{ addressForm.errors?.['formattedAddress'] }}</small
          >
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xl-12">
        <label for="country" class="form-label required-star">
          {{ "address.country" | translate }}
        </label>
        <app-readonly-input
          [value]="addressForm.controls['country']?.value"
        ></app-readonly-input>
        <div
          *ngIf="addressForm.errors?.['country'] && (addressForm.get('country')?.dirty || addressForm.get('country')?.touched)"
        >
          <small
            class="text-danger"
            >{{ addressForm.errors?.['country'] }}</small
          >
        </div>
      </div>
    </div>
    <div class="mb-2">
      <app-app-toggle-accordion #acc="rowAcc">
        <!-- ÜST SATIR -->
        <div
          row
          class="col-xl-12 row align-items-center justify-content-center"
        >
          <div class="col-xl-2">
            <button
              class="btn"
              type="button"
              (click)="acc.toggle()"
              [attr.aria-expanded]="acc.isOpen()"
              aria-controls="acc-panel"
            >
              <span [style.marginLeft.px]="8">{{
                acc.isOpen() ? "▲" : "▼"
              }}</span>
            </button>
          </div>
          <div class="col-xl-5">
            <label for="city" class="form-label required-star">
              {{ "address.city" | translate }}
            </label>
            <app-readonly-input
              [value]="addressForm.controls['city']?.value"
            ></app-readonly-input>
            <div
              *ngIf="addressForm.errors?.['city'] && (addressForm.get('city')?.dirty || addressForm.get('city')?.touched)"
            >
              <small
                class="text-danger"
                >{{ addressForm.errors?.['city'] }}</small
              >
            </div>
          </div>
          <div class="col-xl-5">
            <label for="district" class="form-label required-star">
              {{ "address.district" | translate }}
            </label>
            <app-readonly-input
              [value]="addressForm.controls['district']?.value"
            ></app-readonly-input>
            <div
              *ngIf="addressForm.errors?.['district'] && (addressForm.get('district')?.dirty || addressForm.get('district')?.touched)"
            >
              <small
                class="text-danger"
                >{{ addressForm.errors?.['district'] }}</small
              >
            </div>
          </div>
        </div>

        <!-- ALT PANEL: TÜM SATIRI KAPLAR -->
        <div content>
          <div class="row mb-1">
            <div class="col-xl-6">
              <label for="postalCode" class="form-label">
                {{ "address.postal-code" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['postalCode']?.value"
              ></app-readonly-input>
            </div>
            <div class="col-xl-6">
              <label for="street" class="form-label">
                {{ "address.street" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['street']?.value"
              ></app-readonly-input>
            </div>

            <div class="col-xl-6">
              <label for="latitude" class="form-label">
                {{ "address.latitude" | translate }}
              </label>

              <app-readonly-input
                [value]="addressForm.controls['latitude']?.value"
              ></app-readonly-input>
            </div>
            <div class="col-xl-6">
              <label for="longitude" class="form-label">
                {{ "address.longitude" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['longitude']?.value"
              ></app-readonly-input>
            </div>
          </div>
        </div>
      </app-app-toggle-accordion>
    </div>

    <div class="row mb-1">
      <div class="col-xl-12">
        <label for="addressDescription" class="form-label">
          {{ "address.address-description" | translate }}
        </label>

        @if(isReadOnly){
        <app-readonly-input
          [type]="'textarea'"
          [value]="addressForm.controls['addressDescription']?.value"
        ></app-readonly-input>

        }@else{
        <textarea
          formControlName="addressDescription"
          class="form-control"
          rows="3"
          id="addressDescription"
          placeholder="Adres açıklaması giriniz..."
          (input)="onDesciptionChange()"
        ></textarea>
        }
      </div>
    </div>
  </div>
  <div *ngIf="this.isManualAddress">
    @if(!isReadOnly){
    <div class="row">
      <div class="col-xl-12 mb-1">
        <label for="formattedAddress" class="form-label required-star">{{
          "address.address" | translate
        }}</label>

        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Açık Adres"
            [(ngModel)]="manuelFormattedAddress"
            [disabled]="disableAll"
            (ngModelChange)="onAddressChanged()"
          />
          <span
            class="input-group-text"
            (click)="onNavigateIconClick()" role="button"  tabindex="-1"
            style="cursor: pointer"
          >
            <i class="bi bi-compass"></i>
          </span>

          <span
            *ngIf="patient?.addresses && patient.addresses.length > 0"
            class="input-group-text"
            (click)="onSearchIconClick()" role="button"  tabindex="-1"
            style="cursor: pointer"
          >
            <i class="bi bi-search"></i>
          </span>
        </div>

        <div
          *ngIf="addressForm.errors?.['formattedAddress'] && (addressForm.get('formattedAddress')?.dirty || addressForm.get('formattedAddress')?.touched)"
        >
          <small
            class="text-danger"
            >{{ addressForm.errors?.['formattedAddress'] }}</small
          >
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xl-12">
        <label for="manuelCountry" class="form-label required-star">
          {{ "address.country" | translate }}
        </label>
        <p-dropdown
          [options]="countries"
          [(ngModel)]="manuelCountry"
          [showClear]="true"
          [filter]="true"
          optionLabel="label"
          [disabled]="disableAll"
          appendTo="body"
          [placeholder]="'general.select-please' | translate"
          (ngModelChange)="onCountryChanged($event)"
        >
        </p-dropdown>
        <div
          *ngIf="addressForm.errors?.['country'] && (addressForm.get('country')?.dirty || addressForm.get('country')?.touched)"
        >
          <small
            class="text-danger"
            >{{ addressForm.errors?.['country'] }}</small
          >
        </div>
      </div>
    </div>
    <div class="mb-1">
      <app-app-toggle-accordion #acc="rowAcc">
        <!-- ÜST SATIR -->
        <div
          row
          class="col-xl-12 row align-items-center justify-content-center"
        >
          <div class="col-xl-2">
            <button
              class="btn"
              type="button"
              (click)="acc.toggle()"
              [attr.aria-expanded]="acc.isOpen()"
              aria-controls="acc-panel"
            >
              <span [style.marginLeft.px]="8">{{
                acc.isOpen() ? "▲" : "▼"
              }}</span>
            </button>
          </div>

          <div class="col-xl-5 col-sm-12">
            <label for="manuelCity" class="form-label required-star">
              {{ "address.city" | translate }}
            </label>
            <p-dropdown
              [options]="filteredCities"
              [(ngModel)]="manuelCity"
              [showClear]="true"
              [filter]="true"
              optionLabel="label"
              appendTo="body"
              [disabled]="!manuelCountry || disableAll"
              [placeholder]="'general.select-please' | translate"
              (ngModelChange)="onCityChanged($event)"
            >
            </p-dropdown>
            <div
              *ngIf="addressForm.errors?.['city'] && (addressForm.get('city')?.dirty || addressForm.get('city')?.touched)"
            >
              <small
                class="text-danger"
                >{{ addressForm.errors?.['city'] }}</small
              >
            </div>
          </div>
          <div class="col-xl-5 col-sm-12">
            <label for="manuelDistrict" class="form-label required-star">
              {{ "address.district" | translate }}
            </label>
            <p-dropdown
              [options]="filteredDistricts"
              [(ngModel)]="manuelDistrict"
              [showClear]="true"
              [filter]="true"
              optionLabel="label"
              appendTo="body"
              [disabled]="!manuelCity || disableAll"
              [placeholder]="'general.select-please' | translate"
              (ngModelChange)="onAddressChanged()"
            >
            </p-dropdown>
            <div
              *ngIf="addressForm.errors?.['district'] && (addressForm.get('district')?.dirty || addressForm.get('district')?.touched)"
            >
              <small
                class="text-danger"
                >{{ addressForm.errors?.['district'] }}</small
              >
            </div>
          </div>
        </div>

        <!-- ALT PANEL: TÜM SATIRI KAPLAR -->
        <div content>
          <div class="row mb-1">
            <div class="col-xl-6">
              <label for="postalCode" class="form-label">
                {{ "address.postal-code" | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                placeholder="Posta Kodu"
                [disabled]="disableAll"
                [(ngModel)]="manuelPostalCode"
                (ngModelChange)="onAddressChanged()"
              />
            </div>
            <div class="col-xl-6">
              <label for="street" class="form-label">
                {{ "address.street" | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                placeholder="Sokak"
                [(ngModel)]="manuelStreet"
                [disabled]="disableAll"
                (ngModelChange)="onAddressChanged()"
              />
            </div>

            <div class="col-xl-6">
              <label for="latitude" class="form-label">
                {{ "address.latitude" | translate }}
              </label>
              <input
                type="number"
                class="form-control"
                placeholder="Latitude"
                [(ngModel)]="manuelLatitude"
                (ngModelChange)="onAddressChanged()"
                appPreventNegativeInput
                [inputType]="'float'"
                [disabled]="disableAll"
                [allowNegative]="true"
                [min]="-90"
                [max]="90"
              />
            </div>
            <div class="col-xl-6">
              <label for="longitude" class="form-label">
                {{ "address.longitude" | translate }}
              </label>
              <input
                type="number"
                class="form-control"
                placeholder="Longitude"
                [(ngModel)]="manuelLongitude"
                appPreventNegativeInput
                [inputType]="'float'"
                [allowNegative]="true"
                [min]="-180"
                [max]="180"
                (ngModelChange)="onAddressChanged()"
                [disabled]="disableAll"
              />
            </div>
          </div>
        </div>
      </app-app-toggle-accordion>
    </div>

    <div class="col-xl-12">
      <label for="addressDescription" class="form-label">
        {{ "address.address-description" | translate }}
      </label>
      <textarea
        [(ngModel)]="manuelDescription"
        class="form-control"
        rows="3"
        placeholder="Adres açıklaması giriniz..."
        (ngModelChange)="onAddressChanged()"
      ></textarea>
    </div>
    }@else {
    <div class="row">
      <div class="col-xl-12 mb-1">
        <label for="formattedAddress" class="form-label required-star">{{
          "address.address" | translate
        }}</label>

        <div class="d-flex">
          <div style="flex: 1">
            <app-readonly-input
              [value]="addressForm.controls['formattedAddress']?.value"
            ></app-readonly-input>
          </div>
          <span
            class="input-group-text"
            (click)="onNavigateIconClick()" role="button"  tabindex="-1"
            style="cursor: pointer"
          >
            <i class="bi bi-compass"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xl-12">
        <label for="manuelCountry" class="form-label required-star">
          {{ "address.country" | translate }}
        </label>

        <app-readonly-input
          [value]="addressForm.controls['country']?.value"
        ></app-readonly-input>
      </div>
    </div>
    <div class="mb-1">
      <app-app-toggle-accordion #acc="rowAcc">
        <!-- ÜST SATIR -->
        <div
          row
          class="col-xl-12 row align-items-center justify-content-center"
        >
          <div class="col-xl-2">
            <button
              class="btn"
              type="button"
              (click)="acc.toggle()"
              [attr.aria-expanded]="acc.isOpen()"
              aria-controls="acc-panel"
            >
              <span [style.marginLeft.px]="8">{{
                acc.isOpen() ? "▲" : "▼"
              }}</span>
            </button>
          </div>
          <div class="col-xl-5 col-sm-12">
            <label for="manuelCity" class="form-label required-star">
              {{ "address.city" | translate }}
            </label>
            <app-readonly-input
              [value]="addressForm.controls['city']?.value"
            ></app-readonly-input>
          </div>
          <div class="col-xl-5 col-sm-12">
            <label for="manuelDistrict" class="form-label required-star">
              {{ "address.district" | translate }}
            </label>
            <app-readonly-input
              [value]="addressForm.controls['district']?.value"
            ></app-readonly-input>
          </div>
        </div>

        <!-- ALT PANEL: TÜM SATIRI KAPLAR -->
        <div content>
          <div class="row mb-1">
            <div class="col-xl-6">
              <label for="postalCode" class="form-label">
                {{ "address.postal-code" | translate }}
              </label>

              <app-readonly-input
                [value]="addressForm.controls['postalCode']?.value"
              ></app-readonly-input>
            </div>
            <div class="col-xl-6">
              <label for="street" class="form-label">
                {{ "address.street" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['street']?.value"
              ></app-readonly-input>
            </div>

            <div class="col-xl-6">
              <label for="latitude" class="form-label">
                {{ "address.latitude" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['latitude']?.value"
              ></app-readonly-input>
            </div>
            <div class="col-xl-6">
              <label for="longitude" class="form-label">
                {{ "address.longitude" | translate }}
              </label>
              <app-readonly-input
                [value]="addressForm.controls['longitude']?.value"
              ></app-readonly-input>
            </div>
          </div>
        </div>
      </app-app-toggle-accordion>
    </div>

    <div class="col-xl-12">
      <label for="addressDescription" class="form-label">
        {{ "address.address-description" | translate }}
      </label>
      <app-readonly-input
        [value]="addressForm.controls['addressDescription']?.value"
        [type]="'textarea'"
      ></app-readonly-input>
    </div>
    }
  </div>
</div>

<app-case-patient-address-popup
  (saveOn)="saveAddress($event)"
  #addressPopup
></app-case-patient-address-popup>
